// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__nqBu4","content":"Layout_content__UOgH6"};